export default __webpack_public_path__ + "svg/5ff279a4695032eb778ea291f13e9738.svg";